import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useStyles } from "./styles";

export function Financial() {
  const styles = useStyles();

  return (
    <Stack spacing={2}>
      <div className={styles.root}>
        <Typography variant="h6">Financeiro</Typography>
        <Typography variant="body2">Subtitulo</Typography>
      </div>
    </Stack>
  );
}
